import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantAnticipationHistory = (id, page = 1, term = null) => useQuery({ queryKey: ['consultant-anticipations', id, page, term], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/anticipations?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useConsultantAnticipationHistory